import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import ProgressImage from '../../../components/progress-image';

import './project.css';

const Project = ({ project }) => {
  // const image = project.getIn(['fields', 'thumbnail', 'value', 'sizes', 'preview', 'src']);
  const image = project.getIn(['fields', 'thumbnail', 'value']);


  return (
    <Link to={`/project/${project.get('slug')}`} className="project">

      <div className="image">
        <ProgressImage image={image ? image.toJS() : null} width="100%" height="100%" />
      </div>
      {/* <div className="image"><div style={{ backgroundImage: `url('${image}')` }} /></div> */}
      <h4>{project.get('title')}</h4>
    </Link>
  );
};

Project.propTypes = {
  project: PropTypes.object.isRequired,
};

export default Project;



// WEBPACK FOOTER //
// ./src/containers/projects/project/index.jsx